@if (contentlet$ | async; as contentlet) {
<div class="product-list-container" [ngClass]="contentlet.cssClass">
  <custom-dot-cms-product-carousel-list listStyle="carousel" listItemStyle="tile" [contentlet]="contentlet" />
</div>
}
